import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import styled from 'styled-components'
import { Link } from 'gatsby'

const StyledText = styled.p`
  width: fit-content;
  margin-bottom: 16px !important;
  :after {
    background-color: transparent;
    transition: background-color 0.3s, bottom 0.2s;
    content: '';
    position: absolute;
    bottom: -4px;
    right: 0;
    left: 1px;
    height: 2px;
    background-color: transparent;
    pointer-events: none;
  }
  &:hover {
    :after {
      background-color: #ff6c00 !important;
    }
  }
`

const MobileMenuItem = ({ menuItems }) => (
  <div>
    {menuItems.map(item => (
      <Link to={item.link} key={uuidv4()}>
        <StyledText className="anchor button-link-primary gh-nav-action">{item.title}</StyledText>
      </Link>
    ))}
  </div>
)

export default MobileMenuItem
